export default "__VITE_ASSET__c48d68ff__"